import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { entityWithNameSchema } from '../types';

export type GetCashdeskAllQueryParams = number[];

export const createGetCashdeskAllQuery = () =>
	createAuthQuery({
		params: declareParams<GetCashdeskAllQueryParams>(),
		request: {
			method: 'GET',
			url: '/cashdesk/all',
			query: (ids) => (ids.length > 0 ? { accountIds: ids.map(String) } : {}),
		},
		response: {
			contract: zodContract(entityWithNameSchema.array()),
		},
	});
